import React from "react";
import { ReactComponent as MessageIcon } from "../../../assets/icons/MessageSquareLogo.svg";
import { ReactComponent as EditIcon } from "../../../assets/icons/EditIconLogo.svg";
import { useSelector, useDispatch } from "react-redux";
import { setNote, startEditing, cancelEditing, saveNote } from "../../../store/questionCardReducer";

const InterviewQuestionCard = ({ data }) => {
  const {
    id,
    time,
    score,
    question,
    studentResponse,
    aiFollowUps = [],
    aiAssessment,
    competencies = [],
    adminNotes,
  } = data;
  
  const dispatch = useDispatch();
  const { note, isEditing } = useSelector((state) => state.note)

  const handleSave = () => {
    dispatch(saveNote())
  };

  const handleCancel = () => {
    dispatch(cancelEditing(adminNotes))
  };

  const handleEdit = () =>{
    dispatch(startEditing())
  }

  const handleChange = (e) => {
    dispatch(setNote(e.target.value))
  }
  return (
    <>
    <div className="border border-gray-200 rounded-lg p-6">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <div className="flex items-center space-x-3 mb-2">
            <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full font-medium">
              {id}
            </span>
            <span className="text-sm text-gray-500">{time}</span>
            <div className="px-2 py-1 rounded-full text-xs font-medium text-green-600 bg-green-50">
              {score}
            </div>
          </div>
          <h4 className="font-semibold text-gray-900 mb-3">{question}</h4>
        </div>
      </div>

      <div className="space-y-4">
        <div>
          <h5 className="font-medium text-gray-900 mb-2">Student Response:</h5>
          <p className="text-gray-700 bg-gray-50 p-4 rounded-lg">
            {studentResponse}
          </p>
        </div>

        {aiFollowUps?.length > 0 && (
          <div>
            <h5 className="font-medium text-gray-900 mb-2">
              AI Follow-up Questions:
            </h5>
            <ul className="space-y-2">
              {aiFollowUps.map((q, index) => (
                <li
                  key={index}
                  className="text-gray-700 bg-blue-50 p-3 rounded-lg flex items-start space-x-2"
                >
                    <MessageIcon className="w-5 h-5 text-blue-400 flex-shrink-0 mt-1" />
                  <span>{q}</span>
                </li>
              ))}
            </ul>
          </div>
        )}

        {aiAssessment && (
          <div>
            <h5 className="font-medium text-gray-900 mb-2">AI Assessment:</h5>
            <p className="text-gray-700 bg-yellow-50 p-4 rounded-lg">
              {aiAssessment}
            </p>
          </div>
        )}

        {competencies?.length > 0 && (
          <div>
            <h5 className="font-medium text-gray-900 mb-2">
              Competencies Evaluated:
            </h5>
            <div className="flex flex-wrap gap-2">
              {competencies.map((c, index) => (
                <span
                  key={index}
                  className="bg-purple-100 text-purple-800 text-xs px-2 py-1 rounded-full"
                >
                  {c}
                </span>
              ))}
            </div>
          </div>
        )}

        <div>
          <div className="flex items-center justify-between mb-2">
            <h5 className="font-medium text-gray-900">Admin Notes:</h5>
            {!isEditing && (
            <button
              onClick={handleEdit}
              className="text-blue-600 hover:text-blue-700 text-sm flex items-center space-x-1"
            >
              <EditIcon className="w-4 h-4" />
              <span>Edit</span>
            </button>
          )}
          </div>
          {isEditing ? (
          <div className="space-y-3">
            <textarea
              value={note}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg p-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
              rows={3}
              placeholder="Write admin notes here..."
            />
            <div className="flex space-x-3">
              <button
                onClick={handleSave}
                className="px-4 py-2 bg-yellow-400 text-white text-sm rounded-lg hover:bg-yellow-500"
              >
                Save
              </button>
              <button
                onClick={handleCancel}
                className="px-4 py-2 bg-gray-200 text-gray-800 text-sm rounded-lg hover:bg-gray-300"
              >
                Cancel
              </button>
            </div>
          </div>
        ) : (
          <p className="text-gray-600 bg-gray-50 p-3 rounded-lg italic">
            {adminNotes || "No admin notes added yet."}
          </p>
        )}
        </div>
      </div>
    </div>
    </>
  );
};

export default InterviewQuestionCard;
